module.exports = __webpack_public_path__ + "img/paishui (3).d1b3a7ea.png";